import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { SpinnerIcon, BrokenMediaIcon } from './Icons';
export default function MediaStates(_ref) {
  var loading = _ref.loading,
      error = _ref.error,
      mediaType = _ref.mediaType,
      wrapperClassNames = _ref.wrapperClassNames,
      wrapperStyle = _ref.wrapperStyle,
      isFocused = _ref.isFocused,
      children = _ref.children;
  return React.createElement("div", {
    contentEditable: false,
    spellCheck: false,
    style: _objectSpread({
      minHeight: 94
    }, wrapperStyle),
    className: classNames('flexbox flexbox-align-center flexbox-centered radius-normal border-medium border-shade-50 padding-large background-white', {
      'is-focused': isFocused
    }, wrapperClassNames)
  }, loading && !error && React.createElement(SpinnerIcon, {
    className: "spinner-rotating shade-20",
    size: 24
  }), error && React.createElement("div", {
    className: "line-height-larger font-size-normal flexbox flexbox-align-center width-full"
  }, React.createElement(BrokenMediaIcon, {
    size: 16,
    className: "shade-20"
  }), React.createElement("div", {
    className: "flexbox flexbox-column margin-left-medium"
  }, React.createElement("div", {
    className: "bold shade-05"
  }, "Sorry, there was a problem loading the ", mediaType), React.createElement("div", {
    className: "shade-20"
  }, "Try to refresh or upload it again"))), children);
}